import { render, staticRenderFns } from "./schuhgroessen.vue?vue&type=template&id=10779678&"
import script from "./schuhgroessen.vue?vue&type=script&lang=js&"
export * from "./schuhgroessen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/3672/203/Bigtex5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10779678')) {
      api.createRecord('10779678', component.options)
    } else {
      api.reload('10779678', component.options)
    }
    module.hot.accept("./schuhgroessen.vue?vue&type=template&id=10779678&", function () {
      api.rerender('10779678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/bigtex/schuhgroessen.vue"
export default component.exports